<template>
  <div id="app" v-if="init">

    <TopNav v-if="!hideNav" class="top-nav"></TopNav>

    <div class="content" :class="{'padding-nav': !hideNav}">
      <router-view/>
    </div>

    <WebFooter v-if="!hideFooter"></WebFooter>

    <GlobalConfirmModal />

    <GlobalMsgModal />

    <Transition name="fade">
      <div class="loading-mask" v-if="isStoreBusy">
        <b-spinner></b-spinner>
      </div>
    </Transition>
  </div>
</template>

<script>
import TopNav from '@/components/nav/TopNav';
import { mapActions, mapGetters, mapState } from 'vuex';
import WebFooter from './components/footer/WebFooter.vue';
import GlobalMsgModal from "@/components/GlobalMsgModal.vue";
import GlobalConfirmModal from "@/components/GlobalConfirmModal.vue";

import moment from 'moment';
moment.locale('zh-tw');

export default {
  name: 'AppView',
  metaInfo() {
    return {
    };
  },  
  data() {
    return {
      init: false,
    };
  },
  async mounted() {
    try {
      await this.$store.dispatch('auth/initLoginToken');
      this.init = true;
    } catch(e) {
      console.error(e);
    }
    window.addEventListener("resize", this.resizeHandler);
    document.dispatchEvent(new Event('render-event'));

  },
  created() {
    window.addEventListener("resize", this.resizeHandler);
    this.resizeHandler();
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeHandler);
  },
  components: {
    TopNav,
    WebFooter,
    GlobalMsgModal,
    GlobalConfirmModal,
  },
  watch: {
    $route(to) {
      if (to.meta.noToTop === undefined || !to.meta.noToTop) {
        window.scrollTo(0,0);
      }
      // console.log(to);
    }
  },
  computed: {
    ...mapGetters(['isStoreBusy', 'auth/hasToken']),
    ...mapState(['hideNav', 'hideFooter']),
    // routeName() {
    //   return this.$route.name;
    // },
  },
  methods: {
    ...mapActions(['appendComponentBusy', 'clearComponentBusy', 'appendErrorMsg']),
    resizeHandler() {
      this.$store.commit('SETWINDOWWIDTH', window.innerWidth);
    },
  }
}
</script>


<style lang="scss" scoped>

/* 外層容器：固定在右下角 */
.global-error-modal-wrap {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 12px;
  pointer-events: none;
}

/* 視窗本體 */
.error-modal {
  width: 320px;
  background: #ffffff;
  border-radius: 12px;
  padding: 16px 18px 14px;
  position: relative;
  pointer-events: auto;
  transform: translateY(0);
}

/* 標題 */
.error-title {
  font-weight: bold;
  font-size: 16px;
}

/* 內容 */
.error-desc {
  margin-top: 6px;
  font-size: 14px;
  line-height: 1.5;
}

/* 關閉按鈕 */
.close-btn {
  position: absolute;
  top: 8px;
  right: 10px;
  font-size: 14px;
  cursor: pointer;
  opacity: 0.6;
}

.close-btn:hover {
  opacity: 1;
}

/* 動畫：進場（由下往上） */
.slide-up-modal-enter-active {
  animation: slideUpIn 0.35s ease-out;
}

/* 動畫：離場 */
.slide-up-modal-leave-active {
  animation: slideUpOut 0.25s ease-in forwards;
}

@keyframes slideUpIn {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideUpOut {
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(30px);
  }
}

.loading-mask {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: #0005;
  opacity: 1;
  z-index: 99999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .5s ease;
}


</style>

<style lang="scss">
@import "@/assets/scss/main.scss";
#app {
  color: #333333;
}

.top-nav {
  position: fixed !important;
  z-index: 100;
  top: 0;
  left: 0;
  width: 100%;
}

.padding-nav {
  padding-top: 96px;
  @include smaller-than-large {
    padding-top: 72px;
  }
}
</style>